import React, { useState } from "react";
import Adminnav from "../Adminnav";
import axios from "axios";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const AddCoupons = () => {
  const [code, setCode] = useState("");
  const [discount, setDiscount] = useState();

  function add() {
    axios.post(
      `${BaseURL}AddCoupons`,
      {
        couponCode: code,
        discount: discount,
      },
      { headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") } }
    );
    toastify("Coupon Added Successfully", "success");
  }

  return (
    <>
      <Adminnav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Add Coupons</h1>
          </div>
        </div>
      </section>
      <div className="form-container">
        <form action="" className="checkout-form">
          <div className="input-line">
            <label htmlFor="code">Coupon Code</label>
            <input
              type="text"
              name="code"
              id="code"
              placeholder="Coupon Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="discount">Discount Price</label>
            <input
              type="text"
              name="discount"
              id="discount"
              placeholder="Discount"
              value={discount}
              onChange={(e) => setDiscount(e.target.value)}
            />
          </div>
        </form>
        <button
          type="button"
          className="btn btn-success addcoupon"
          onClick={() => add()}
        >
          Add Coupon
        </button>
      </div>
    </>
  );
};

export default AddCoupons;
